package io.horion.auth.api.services

import kotlinx.serialization.Serializable

@Serializable
data class Success(
    val message: String,
    val attemptsRemaining: String? = null,
    val canRetry: Boolean? = null,
    val canRequestNewCode: Boolean? = null
)